import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import { IconFlagGreen, IconCheckBoxGreen } from '../../1-foundation/icons/icons';
import Card from '../../3-molecules/card/card';

import { optionModifiersList, tagList } from './prop-list';

const DEFAULT_ITEM_ACTIVATED = false;
const DEFAULT_OPTION_MODIFIERS = [];
const DEFAULT_TAG = 'button';
const DEFAULT_TARGET = '_blank';
const RADIO_MODIFIER = 'radio';
const CHECKBOX_MODIFIER = 'checkbox';
const DEFAULT_ON_CLICK = () => {};

const Option = ({
  text,
  urlLink,
  labelLink,
  isActive = DEFAULT_ITEM_ACTIVATED,
  isDisabled,
  modifiers = DEFAULT_OPTION_MODIFIERS,
  onClick = DEFAULT_ON_CLICK,
  tag = DEFAULT_TAG,
  href,
  target = DEFAULT_TARGET,
  image,
  intcmp,
  card,
}) => {
  const Tag = tag;
  const type = tag === DEFAULT_TAG ? 'button' : null;
  let classNames = getClassNames('c-option', modifiers);
  if (isActive) {
    classNames += ' is-active';
  }
  if (isDisabled) {
    classNames += ' is-disabled';
  }
  let IconOption;
  if (modifiers.includes(RADIO_MODIFIER)) {
    IconOption = IconFlagGreen;
  }
  if (modifiers.includes(CHECKBOX_MODIFIER)) {
    IconOption = IconCheckBoxGreen;
  }

  return (
    <Tag
      type={type}
      href={href}
      target={target}
      className={classNames}
      onClick={onClick}
      data-intcmp={Tag === 'a' ? intcmp : undefined}
    >
      {image && (
        <span className="c-option__container">
          <img className="c-option__image" src={image} />
        </span>
      )}
      {text && <span className="c-option__text">{text}</span>}
      {urlLink && (
        <a href={urlLink} target={target} className="c-option__link" data-intcmp={intcmp}>
          {labelLink}
        </a>
      )}
      {card && <Card {...card} />}
      {isActive && IconOption && (
        <span className="c-option__icon">
          <IconOption modifiers={['xsmall']} />
        </span>
      )}
    </Tag>
  );
};

Option.propTypes = {
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isNotClickable: PropTypes.bool,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(optionModifiersList)),
  onClick: PropTypes.func,
  tag: PropTypes.oneOf(tagList),
  href: PropTypes.string,
  target: PropTypes.string,
  type: PropTypes.string,
  image: PropTypes.string,
  text: PropTypes.string,
  urlLink: PropTypes.string,
  labelLink: PropTypes.string,
  intcmp: PropTypes.string,
  card: PropTypes.object,
};

export default Option;
